module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('span', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/books#c01k",
      "id": "c1k"
    }
  }, [_vm._v("The Books of the Torah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/tot#c02k",
      "id": "c2k"
    }
  }, [_vm._v("Timeline of the Torah and Judaic History")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/intro#c03k",
      "id": "c3k"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/image#c04k",
      "id": "c4k"
    }
  }, [_vm._v("Image Gallery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1#c01",
      "id": "c1"
    }
  }, [_vm._v("A Note to the Reader")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter2#c02",
      "id": "c2"
    }
  }, [_vm._v("The Men Behind the Book")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter3#c03",
      "id": "c3"
    }
  }, [_vm._v("From the Books of Moses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#c04",
      "id": "c4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ballad of Job")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#c05",
      "id": "c5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poems of King David")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#c06",
      "id": "c6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parables of King Solomon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#c07",
      "id": "c7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Solomon's Elegy on Vanity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#c08",
      "id": "c8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Vision of Isaiah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9#c09",
      "id": "c9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lament of Jeremiah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#c010",
      "id": "c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ethics of King Solomon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#c011",
      "id": "c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aphorisms of Jeshu ben Sirah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#c012",
      "id": "c12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Love Songs of King Solomon")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-624f1122","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 66
// module chunks = 0